try {

	let player;
    let YTAPIReady = false;
    let videoDuration = 0;
    let videoTitle = "";
    let videoURL = "";
    let videoStartEventCount = 0;
    let videoProgressMarkers = { 25: false, 50: false, 75: false };
    let videoInterval;

    /**
     * Handles player readiness.
     * @param {Object} event - YouTube Player event object.
     */
    function onPlayerReady(event) {
        videoDuration = player.getDuration() || 0;
    }

    /**
     * Handles player state changes (play, pause, complete, etc.).
     * @param {Object} event - YouTube Player event object.
     */
    function onPlayerStateChange(event) {
        if (!videoTitle) videoTitle = event.target?.videoTitle || "";
        if (!videoURL) videoURL = event.target?.playerInfo?.videoUrl || "";
        videoDuration = event.target?.playerInfo?.duration || 0;

        switch (event.data) {
            case 1: // Video is playing
                if (videoStartEventCount === 0) {
                    sendGA4VideoEvent("ga4_video_start");
                    videoStartEventCount++;
                }
                trackVideoProgress(event);
                break;
            
            case 0: // Video completed
                sendGA4VideoEvent("ga4_video_complete", videoDuration, 100);
                clearInterval(videoInterval);
                break;
            
            default: // Any other state (paused, buffering, etc.)
                clearInterval(videoInterval);
                break;
        }
    }

    /**
     * Initializes the YouTube Player for dynamically created iframe.
     */
    function initializeYTPlayer() {

        const videoElement = document.getElementById("dynamic-video");

        if (videoElement && typeof YT !== "undefined" && YT.loaded) {
            player = new YT.Player("dynamic-video", {
                events: {
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange,
                },
            });
            console.info('YouTube player is initialized.');
        }
    }

	/**
     * Stops the video playback safely.
     */
    function stopVideo() {
        try {
            player?.stopVideo();
        } catch (error) {
            console.error("Error stopping video:", error);
        }
    }

	/**
     * Tracks the video progress and triggers GA4 events at 25%, 50%, and 75%.
     * @param {Object} event - YouTube Player event object.
     */
    function trackVideoProgress(event) {
        videoInterval = setInterval(() => {
            const currentTime = event.target?.playerInfo?.currentTime || 0;
            const progressPercent = (currentTime / videoDuration) * 100;

            for (const marker of [25, 50, 75]) {
                if (progressPercent >= marker && !videoProgressMarkers[marker]) {
                    sendGA4VideoEvent("ga4_video_progress", currentTime, marker);
                    videoProgressMarkers[marker] = true;
                }
            }
        }, 1000);
    }	

	/**
     * Sends video tracking event data to Google Analytics 4 (GA4).
     * @param {string} eventName - Event name (e.g., "ga4_video_start").
     * @param {number} [videoCurrentTime=0] - Current playback time.
     * @param {number} [videoPercent=0] - Video progress percentage.
     */
    function sendGA4VideoEvent(eventName, videoCurrentTime = 0, videoPercent = 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            ga4_data: {
                video_provider: "YouTube",
                video_title: videoTitle,
                video_url: videoURL,
                video_current_time: Math.floor(videoCurrentTime),
                video_percent: videoPercent,
                video_duration: Math.ceil(videoDuration),
                visible: 1,
            },
        });
    }

    document.addEventListener("DOMContentLoaded", function() {
        const videoElement = document.querySelector(".featured-video--without-placeholder-image");

        if (!videoElement) return; // If it doesn't exist, return.

        let hasFired = false; // Stop executing video loading multiple times.

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !hasFired) {
                    const videoLazyLoad = entry.target.querySelector('.video-lazy-load');
                    if (videoLazyLoad) {
                        const iframe = document.createElement("iframe");
                        iframe.src = videoLazyLoad.dataset.src;
                        iframe.width = "850";
                        iframe.height = "480";
                        iframe.frameBorder = "0";
                        iframe.allowFullscreen = true;
                        iframe.id = "dynamic-video";

                        // Insert the iframe before the videoLazyLoad element
                        videoLazyLoad.parentNode.insertBefore(iframe, videoLazyLoad);

                        if (videoLazyLoad.dataset.type === 'youtube') {
                            initializeYTPlayer();
                        }
                    }

                    hasFired = true;
                    observer.disconnect(); // Stop the observation.
                }
            });
        }, {
            root: null, // Observe the whole viewport.
            rootMargin: "300px 0px 300px 0px", // obesve the top and bottom 300px around the DOM element.
            threshold: 0 // Run the code, when the user reaches the first pixel.
        });

        observer.observe(videoElement);
    });

} catch (error) {
	console.log('Youtube API Error: ', error)
}
